import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import translations from '../utils/i18n';

const COUNTRY_LANG = { UK: 'en', IN: 'hi', CA: 'fr' };
const LANG_LABELS = { en: 'English', hi: 'हिन्दी', fr: 'Français' };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  // Always default to English — AI translation is only on Blog page
  const [lang] = useState('en');

  // Clear any saved non-English preference from old sessions
  useEffect(() => {
    localStorage.removeItem('shopperden_lang');
  }, []);

  const changeLang = useCallback(() => {}, []);
  const setLangFromCountry = useCallback(() => {}, []);

  const t = useCallback((key) => {
    const parts = key.split('.');
    let val = translations[lang];
    for (const p of parts) {
      val = val?.[p];
    }
    if (val) return val;
    // Fallback to English
    val = translations.en;
    for (const p of parts) {
      val = val?.[p];
    }
    return val || key;
  }, [lang]);

  const availableLangs = useMemo(() => Object.keys(translations), []);

  const contextValue = useMemo(() => ({
    lang, changeLang, setLangFromCountry, t, LANG_LABELS, availableLangs
  }), [lang, changeLang, setLangFromCountry, t, availableLangs]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
